import { TFilters } from "@hooks/useFiltersQuery/types";

import { FormikValues } from "formik";
import isEqual from "lodash/isEqual";

import { IFilters } from "@/models/models";

export const getInitialValues = (filters: IFilters) => {
  return {
    ...filters,
    bpm: [filters.bpm?.min ?? 0, filters.bpm?.max ?? 0],
    length: [filters.length?.min ?? 0, filters.length?.max ?? 0],
  };
};

export const valuesAdapter = (values: FormikValues, prevState: IFilters, initialValues: any) => {
  return Object.keys(prevState).reduce((acc, key) => {
    if (isEqual(values[key], initialValues[key])) {
      acc[key] = prevState[key];
      return acc;
    }

    if (key === "bpm" || key === "length") {
      if (values[key].every((el) => el === 0)) {
        acc[key] = null;
        return acc;
      }
      acc[key] = {
        min: values[key][0],
        max: values[key][1],
      };
      return acc;
    }

    acc[key] = values[key];
    return acc;
  }, {} as TFilters);
};
